import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Logo from '../assets/Images/logo.png';
import { logout } from '../redux-toolkit/Slice/loginSlice';
import { useDispatch } from 'react-redux';

import { toast } from 'react-toastify';

const Sidebar = ({ isOpen, setIsAuthenticated }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // const [productsOpen, setProductsOpen] = useState(false);
  // const [pharmaceuticalOpen, setPharmaceuticalOpen] = useState(false);
  // const [nutraceuticalOpen, setNutraceuticalOpen] = useState(false);
  // const [ayurvedicOpen, setAyurvedicOpen] = useState(false);

  // const toggleProducts = () => setProductsOpen(!productsOpen);
  // const togglePharmaceutical = () => setPharmaceuticalOpen(!pharmaceuticalOpen);
  // const toggleNutraceutical = () => setNutraceuticalOpen(!nutraceuticalOpen);
  // const toggleAyurvedic = () => setAyurvedicOpen(!ayurvedicOpen);

  // const handleLogout = (e) => {
  //   e.preventDefault();

  //   dispatch(logout());
  //   toast.success('Log out successfully!');
  //   setIsAuthenticated(false);
  //   navigate('/login', { replace: true });
  // };

  const handleLogout = (e) => {
    e.preventDefault();

    dispatch(logout());
    toast.success('Log out successfully!');

    // Delay navigation to allow toast to show
    setTimeout(() => {
      setIsAuthenticated(false);
      navigate('/login', { replace: true });
    }, 1000); // 1-second delay before navigation
  };

  return (
    <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
      <div className='text-center'>
        <Link to='/product'><img src={Logo} alt="Logo" className='logo' /></Link>
      </div>
      <ul className='navbar flex-column align-items-start mt-4'>
        <li className='nav-item'><Link className={`nav-link ${location.pathname === '/product' ? 'active' : ''}`} to="/product">All Products</Link></li>
        <li className='nav-item'><Link className={`nav-link ${location.pathname === '/Productstype' ? 'active' : ''}`} to="/Productstype">Products Type</Link></li>
        <li className='nav-item'><Link className={`nav-link ${location.pathname === '/Blog' ? 'active' : ''}`} to="/Blog">Blog</Link></li>
        <li className='nav-item'><Link className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`} to="/contact">Contact</Link></li>
        <li className='nav-item'><Link className={`nav-link ${location.pathname === '/feedback' ? 'active' : ''}`} to="/feedback">feedback</Link></li>
        <li className='nav-item'><Link className={`nav-link ${location.pathname === '/' ? 'active' : ''}`} onClick={handleLogout}>Logout</Link></li>
      </ul>
    </aside>
  );
};

export default Sidebar;




